import {coreApi} from './core'

export const companiesService = {

    getAll: () => coreApi.get(`company`),
    getById: (id) => coreApi.get(`company?id=${id}`),
    getCompanyById: (params) => coreApi.get(`/contract/company/`, {params}),
    create: (data) => coreApi.post(`/company`, data),
    seller: () => coreApi.get('company/seller'),
    getSellerById: (id) => coreApi.get(`company/seller/${id}`),
    createSeller: (data) => coreApi.post('company/seller/create', data),
    updateSeller: (data) => coreApi.put('company/seller/update', data),
    update: (data) => coreApi.put(`/company`, data),
    paginate: (offset) => coreApi.get(`company/${offset}`),
    getByDate: (start, end) => coreApi.get(`/company/search?start=${start}&end=${end}`),
}
